import { captureException } from '@sentry/browser';
import { createLoader, useRead } from '@spotify-internal/creator-data-loading';
import { webgateFetch, WEBGATE_DOMAIN } from '../../shared/lib/api';
import { withHooks } from '../../shared/lib/withHooks';

export const endpoint = `${WEBGATE_DOMAIN}/s4x-me/v0/me/features`;

export const currentUserFeaturesLoader = createLoader(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async (_key: 0) => {
    const response = await webgateFetch(endpoint);

    try {
      if (!response.ok) return {};
      const { features } = (await response.json()) as Data;
      return features;
    } catch (error) {
      captureException(error);
      return {};
    }
  },
  {
    cacheKeyFn: () => 0,
  },
);

/** @deprecated https://backstage.spotify.net/docs/mrkt-web/migrations/abba/#usecurrentuserfeaturesdeprecated */
export function useCurrentUserFeaturesDEPRECATED() {
  return useRead(currentUserFeaturesLoader, 0);
}

/** @deprecated https://backstage.spotify.net/docs/mrkt-web/migrations/abba/#withcurrentuserfeaturesdeprecated */
export const withCurrentUserFeaturesDEPRECATED = withHooks(() => ({
  features: useCurrentUserFeaturesDEPRECATED(),
}));

type Data = {
  features: {
    [s: string]: string;
  };
};
